import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../../actions/alert';
import { buscarProductosConfiguracion } from '../../../actions/configuracion';
import { crearProductoProveedor } from '../../../actions/proveedores';
import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const NuevoProductoProveedor = ({ show, idProveedor, onClose }) => {
    const dispatch = useDispatch();

    const { listado: catalogoProductos } = useSelector(
        state => state.configuracion.productos
    );

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [formData, setFormData] = useState({
        id_producto: null,
        codigo_proveedor: '',
        precio_publico: '',
        precio_minimo: '',
        precio_liquidacion: '',
    });

    const [productoSelect, setProductoSelect] = useState(null);
    const [productosOptions, setProductosOptions] = useState([]);

    const styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: provided => ({ ...provided }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: 'visible',
            marginTop: '10px',
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: 'absolute',
            top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
            transition: 'top 0.1s, font-size 0.1s',
            fontSize:
                (state.hasValue || state.selectProps.inputValue) && 13,
        }),
    };

    const handleInputChange = ({ target }) => {
        setFormData({
            ...formData,
            [target.name]: target.value,
        });
    };

    const handleSelectProducto = option => {
        setProductoSelect(option);
        setFormData({
            ...formData,
            id_producto: option ? option.value : null,
        });
    };

    const handleAbrir = () => {
        // si no hay catálogo cargado, lo pedimos
        if (!catalogoProductos || catalogoProductos.length === 0) {
            dispatch(
                buscarProductosConfiguracion({
                    nombre: null,
                    id_categoria: null,
                    id_subcategoria: null,
                    codigo_tienda: null,
                })
            );
        }
    };

    const handleCerrar = () => {
        if (statusProcesar) return;

        setFormData({
            id_producto: null,
            codigo_proveedor: '',
            precio_publico: '',
            precio_minimo: '',
            precio_liquidacion: '',
        });
        setProductoSelect(null);

        onClose();
    };

    const handleProcesar = async () => {
        const {
            id_producto,
            codigo_proveedor,
            precio_publico,
            precio_minimo,
            precio_liquidacion,
        } = formData;

        if (!id_producto) {
            dispatch(setAlert('Selecciona un producto', 'danger'));
            return;
        }

        if (!codigo_proveedor) {
            dispatch(
                setAlert('El código del proveedor es requerido', 'danger')
            );
            return;
        }

        if (
            !precio_publico ||
            !precio_minimo ||
            !precio_liquidacion
        ) {
            dispatch(
                setAlert('Los tres precios son requeridos', 'danger')
            );
            return;
        }

        const payload = {
            id_proveedor: idProveedor,
            id_producto,
            codigo_proveedor,
            precio_publico,
            precio_minimo,
            precio_liquidacion,
        };

        try {
            setStatusProcesar(true);
            await dispatch(crearProductoProveedor(payload));
            handleCerrar();
        } finally {
            setStatusProcesar(false);
        }
    };

    useEffect(() => {
        const opts =
            catalogoProductos?.map(p => ({
                value: p._id,
                label: `${p.codigo_tienda || ''} - ${p.nombre}`,
            })) || [];

        setProductosOptions(opts);
    }, [catalogoProductos]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .select-group {
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal
                show={show}
                size="lg"
                backdrop="static"
                centered
                onEntered={handleAbrir}
                onHide={handleCerrar}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Agregar producto al proveedor
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    name="id_producto"
                                    className="select-group w-100"
                                    classNamePrefix="react-select"
                                    placeholder="Selecciona un producto"
                                    options={productosOptions}
                                    value={productoSelect}
                                    isClearable={true}
                                    isSearchable={true}
                                    onChange={handleSelectProducto}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{
                                        ValueContainer: CustomValueContainer,
                                    }}
                                    styles={styles_select}
                                />
                            </div>
                        </div>

                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código proveedor"
                                        id="codigo_proveedor"
                                        name="codigo_proveedor"
                                        value={formData.codigo_proveedor}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="codigo_proveedor">
                                        Código proveedor
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div className="row">
                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Precio público"
                                        id="precio_publico"
                                        name="precio_publico"
                                        value={formData.precio_publico}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="precio_publico">
                                        Precio público
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Precio mínimo"
                                        id="precio_minimo"
                                        name="precio_minimo"
                                        value={formData.precio_minimo}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="precio_minimo">
                                        Precio mínimo
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Precio liquidación"
                                        id="precio_liquidacion"
                                        name="precio_liquidacion"
                                        value={formData.precio_liquidacion}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="precio_liquidacion">
                                        Precio liquidación
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {statusProcesar ? (
                        <button
                            type="button"
                            className="btn btn-success"
                            disabled
                        >
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>{' '}
                            Guardando
                        </button>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCerrar}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleProcesar}
                            >
                                <i className="fas fa-check fa-sm"></i>{' '}
                                Guardar
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default NuevoProductoProveedor;
